export type SDK_ERROR_KEY =
  | 'invalidApiKey'
  | 'invalidSessionId'
  | 'invalidPaymentElementOptions'
  | 'invalidPaymentInstructionsElementOptions'
  | 'invalidDocumentCollectorElementOptions'
  | 'invalidLRSElementOptions'
  | 'paymentElementContainerNotPresent'
  | 'documentCollectorElementContainerNotPresent'
  | 'lrsElementContainerNotPresent'
  | 'invalidPaymentMethodSelectorElementOptions'
  | 'paymentMethodSelectorElementContainerNotPresent'
  | 'invalidRecipientFieldsElementOptions'
  | 'recipientFieldsElementContainerNotPresent';

const SDK_ERROR_MSG: Record<SDK_ERROR_KEY, string | undefined> = {
  invalidApiKey: 'Impossible to start Flywire SDK: invalid API Key',
  invalidSessionId: 'Impossible to create element: session not found',
  invalidPaymentElementOptions: undefined,
  invalidPaymentInstructionsElementOptions: undefined,
  invalidDocumentCollectorElementOptions: undefined,
  invalidLRSElementOptions: undefined,
  invalidPaymentMethodSelectorElementOptions: undefined,
  paymentElementContainerNotPresent:
    'When instantiating the payment element in container mode, an HTML element with the id provided must be present in the DOM',
  documentCollectorElementContainerNotPresent:
    'When instantiating the document collector element in container mode, an HTML element with the id provided must be present in the DOM',
  lrsElementContainerNotPresent:
    'When instantiating the LRS element in container mode, an HTML element with the id provided must be present in the DOM',
  paymentMethodSelectorElementContainerNotPresent:
    'When instantiating the payment method selector element in container mode, an HTML element with the id provided must be present in the DOM',
  invalidRecipientFieldsElementOptions: undefined,
  recipientFieldsElementContainerNotPresent:
    'When instantiating the recipient fields element in container mode, an HTML element with the id provided must be present in the DOM'
};

export class SDKError extends Error {
  public type: SDK_ERROR_KEY;
  public payload: object;

  constructor(type: SDK_ERROR_KEY, message?: string, payload: object = {}) {
    super(message || SDK_ERROR_MSG[type]);

    this.type = type;
    this.payload = payload;

    this.name = this.constructor.name;

    // For better stack traces in v8
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
